import { render, staticRenderFns } from "./GovernateDelete.vue?vue&type=template&id=79a311a9&scoped=true&"
import script from "./GovernateDelete.vue?vue&type=script&lang=js&"
export * from "./GovernateDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a311a9",
  null
  
)

export default component.exports